import {
  AnyPartType,
  partTypeAccessory,
  partTypePackage,
  partTypeTire,
  partTypeWheel,
} from "../../constants/partTypes";
import { useLanguage } from "../../i18n/useLanguage";
import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";

export const useDealerPricingNotes = (partType: AnyPartType): null | string => {
  const dealerAccountInfo = useNullableDealerAccountInfo();
  const [language] = useLanguage();

  switch (partType) {
    case partTypeAccessory:
      return dealerAccountInfo?.dealerAccessoryPricingNote[language] || null;
    case partTypePackage:
      return dealerAccountInfo?.dealerPackagePricingNote[language] || null;
    case partTypeTire:
      return dealerAccountInfo?.dealerTirePricingNote[language] || null;
    case partTypeWheel:
      return dealerAccountInfo?.dealerWheelPricingNote[language] || null;

    default:
      return null;
  }
};
